import React from 'react'
import './index.css'

const Image = ({ imgUrl, onClick }) => {
    return (
        <div className="thumbnail-image-wrap" onClick={onClick}>
            <img src={imgUrl} alt="thumbnail" />
        </div>
    )
}

export default Image
